import { ContactQuestion } from "./contact-question";
import type { QuestionTypeRendererProps } from "./shared";

type PhoneQuestionProps = QuestionTypeRendererProps<"phone">;

export default function PhoneQuestionType(props: PhoneQuestionProps) {
  return <ContactQuestion {...props} kind="phone" />;
}
